export function FAQ() {
  const faqs = [
    {
      question: 'Can I try Napster for free?',
      answer:
        'Absolutely! Start with 100 free minutes to explore the platform and experience the power of AI mentorship.',
    },
    {
      question: `Do I need a credit card to start?`,
      answer:
        'Nope. Create your free account and enjoy 100 minutes on us—no card required.',
    },
    {
      question: 'What happens after I exceed my monthly minutes?',
      answer:
        "We'll notify you when you're close to your limit. You can then buy one of the hourly packs or wait untill a new billing period begins and your minutes are recharged.",
    },
    {
      question: "What happens if I don't use all my minutes?",
      answer:
        'The minutes associated with the monthly or annual subscriptions do not roll over between months. However, the minutes associated with the hourly packs will never expire.',
    },
    {
      question: 'Can I upgrade or cancel anytime?',
      answer:
        'Yes—make changes in My Account → Billing. Updates take effect at the next billing cycle.',
    },
    {
      question: 'How do I create my own Companion?',
      answer:
        "Coming soon for all users, you'll have access to our intuitive agent creation tool, allowing you to define the expertise, style, and capabilities.",
    },
    {
      question: 'How are Companions created?',
      answer:
        'The system auto-spawns a new Companion whenever user demand emerges for a topic. It analyses the question, picks / builds the best persona on the fly, and adds it to the catalog.',
    },
    {
      question: 'How are my minutes consumed?',
      answer:
        'We always use the minutes that come with your active monthly or annual subscription first. \
        If you finish those before the billing period ends, we’ll automatically switch to any Hourly Pack minutes you’ve purchased (they never expire). \
        This way, the minutes that would otherwise disappear at the end of the cycle are used up before we touch your evergreen pack minutes—so you get maximum value from every plan.',
    },
    {
      question: 'Can I subscribe from anywhere in the world?',
      answer:
        'Not yet. Paid subscriptions are currently available only in the US, excluding Alaska, Louisiana and Colorado. We’re working on expanding access soon!',
    },
  ]

  return (
    <div className="mt-20">
      <div className=" mx-auto max-w-7xl">
        <h2 className="text-3xl font-bold text-center text-white mb-6">
          Frequently Asked Questions
        </h2>
        <div className="flex flex-col gap-4">
          {faqs.map(faq => (
            <div key={faq.question} className="tc-mv-blur p-6  ">
              <h3 className="text-lg/base text-white">{faq.question}</h3>
              <p className="text-dark-neutral-200 mt-4">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
